module.exports = __webpack_public_path__ + "static/img/goodsList_loading_jinridui.c37e376a.png";